'use client'

import { useEffect, useState } from 'react'
import { cx } from 'utils/cx'

import styles from './ProgressBar.module.scss'

export type ProgressBarProps = {
	readonly max: number
	readonly value: number
	readonly label: string
	readonly initialValue?: number
	readonly className?: string
	readonly 'data-testid'?: string
}

export const ProgressBar = ({
	max,
	value,
	initialValue,
	className,
	label,
	'data-testid': dataTestId,
}: ProgressBarProps) => {
	const [progress, setProgress] = useState<number>(initialValue ?? 0)

	useEffect(() => {
		setProgress(value)
	}, [value, max])

	return (
		<progress
			className={cx(styles.progressBar, !!className && className)}
			max={max}
			value={progress}
			aria-label={label}
			data-testid={dataTestId}
		>
			{progress}
		</progress>
	)
}
